function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h240v240H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#371447",
  strokeWidth: 3,
  d: "M18.926 66.749v13.475l98.73 29.126 99.915-29.126v-7.431"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.656 67.618l2.397-3.648c.428-.066 31.818-6.857 94.17-20.374 45.543 10.365 78.51 17.914 98.902 22.647.16.037 1.298.908 3.412 2.613l.04 4.404",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.182 57.146L80.398 83.407c-1.796.49-3.01 1.105-3.64 1.845-.63.74-1.08 2.078-1.35 4.013v110.312l-12.038-3.302V85.695c.28-1.876.742-3.513 1.385-4.913.643-1.399 2.78-2.597 6.409-3.593l85.288-22.48 10.73 2.437z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.926 57.146l86.784 26.261c1.796.49 3.01 1.105 3.64 1.845.63.74 1.08 2.078 1.35 4.013v110.312l12.037-3.302V85.695c-.28-1.876-.742-3.513-1.385-4.913-.642-1.399-2.779-2.597-6.408-3.593l-85.289-22.48-10.73 2.437z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.056 82.633v102.455l92.456 26.608 92.507-26.609V82.633l-92.482 26.615-92.481-26.615z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.444 66.772c.486-7.29 3.214-15.258 8.184-23.903C50.598 34.224 55.685 28.6 60.887 26c33.577 17.726 51.59 28.998 54.037 33.817 2.448 4.819 3 7.073 1.653 6.761-2.169 2.73-3.33 4.084-3.483 4.062-14.917-2.189-26.725-2.908-35.423-3.433-8.832-.533-22.24-.678-40.227-.435z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M193.366 66.772c-.486-7.29-3.213-15.258-8.184-23.903-4.97-8.645-10.057-14.268-15.259-16.869-33.577 17.726-51.59 28.998-54.037 33.817-2.448 4.819-2.362 7.723.258 8.714.895 1.428 1.419 2.131 1.572 2.109 14.917-2.189 26.725-2.908 35.423-3.433 8.832-.533 22.24-.678 40.227-.435z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.793 70.505L104.11 56.2c2.538-1.036 6.688-1.532 12.448-1.488 5.76.044 9.616.601 11.566 1.671l-5.25 14.122c-1.113.873-3.25 1.31-6.409 1.31s-5.717-.437-7.673-1.31z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M118 210.53v-88.215 88.215z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  fill: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-2 2362.927 -703.751)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-2 2444.362 -963.056)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-2 2525.797 -1222.361)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-2 2607.232 -1481.666)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-2 2688.667 -1740.97)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-2 2770.102 -2000.276)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-2 2851.537 -2259.58)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-2 2932.972 -2518.885)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-2 3014.407 -2778.19)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-2 3095.841 -3037.495)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
}))), /*#__PURE__*/React.createElement("g", {
  fill: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  transform: "scale(-1 1) rotate(-2 2245.168 6042.642)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(-1 1) rotate(-2 2326.603 5783.337)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(-1 1) rotate(-2 2408.038 5524.033)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(-1 1) rotate(-2 2489.473 5264.728)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(-1 1) rotate(-2 2570.908 5005.423)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(-1 1) rotate(-2 2652.343 4746.118)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(-1 1) rotate(-2 2733.778 4486.813)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(-1 1) rotate(-2 2815.213 4227.509)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(-1 1) rotate(-2 2896.648 3968.204)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "scale(-1 1) rotate(-2 2978.083 3708.899)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
}))));

function SvgOccasionsXl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgOccasionsXl;